import { render, staticRenderFns } from "./inputFilePDF.vue?vue&type=template&id=1b04fc28&scoped=true"
import script from "./inputFilePDF.vue?vue&type=script&lang=js"
export * from "./inputFilePDF.vue?vue&type=script&lang=js"
import style0 from "./inputFilePDF.vue?vue&type=style&index=0&id=1b04fc28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b04fc28",
  null
  
)

export default component.exports